import React, { Component } from 'react';

class FasesConflitantes extends Component {
  constructor(props) {
    super(props);
    this.geralFasesConflito = this.geralFasesConflito.bind(this);
  }

  geralFasesConflito() {
    let faseGrupoObj = [];
    let fasesIni = parseInt(this.props.faseInicial)+1;
    let fasesFin = this.props.faseFinal;
    
    // Pega o primeiro elemento do array ou o próprio objeto se não for array
    const faseConflitanteData = Array.isArray(this.props.info_fases_conflitantes) 
        ? this.props.info_fases_conflitantes[0] 
        : this.props.info_fases_conflitantes;

    for (let idxFase = fasesIni; idxFase <= fasesFin; idxFase++) {
        let faseObj = [];
        for (let idx = fasesIni; idx <= idxFase; idx++) {
            let sName = `fase${idx - 1}_fase${idxFase}`;
            // Apenas marca o checkbox se o valor for explicitamente true (não conflitante)
            // Se é false ou undefined, não marca (conflitante ou não configurado)
            const valorFase = faseConflitanteData ? faseConflitanteData[sName] : undefined;
            const isChecked = valorFase === true;
            
            faseObj.push(
                <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '15px' }}>
                    <input 
                        name={sName} 
                        key={`fase${idx - 1}_fase${idxFase}`}  
                        type="checkbox" 
                        checked={isChecked} 
                        readOnly
                        style={{
                            accentColor: isChecked ? '#d3d3d3' : undefined,
                            cursor: 'default'
                        }}
                    ></input>
                    <span style={{ marginLeft: '5px' }}>{`F${idx - 1} c/ F${idxFase}`}</span>
                </label>
            );
        }   
        faseGrupoObj.push(<div key={`fase${idxFase}`}>{faseObj}</div>);
    }

    return faseGrupoObj;
  }

  render() {
    return (
      <div>
        <div>
          <h4>Fases não conflitantes: </h4>
        </div>
        {this.geralFasesConflito()}
      </div>
    );
  }
}

export default FasesConflitantes;
